import React, { useContext } from 'react'
import { CallBoth } from '~/service/SipConn'
import { UsersManagerContext } from '~/service/UsersManager'
import { VolumeMeterContext } from '~/service/VolumeMeter'

type Props = {
  call: CallBoth
}

const Avatar: React.FC<Props> = ({ call }) => {
  const { remoteRef } = useContext(VolumeMeterContext)
  const { get } = useContext(UsersManagerContext)

  if (!call.client) {
    return null
  }

  const transferingUser =
    call.apiData &&
    call.isIncoming &&
    call.transferedToMeStatus &&
    call.apiData.userId &&
    get(call.apiData.userId)

  return (
    <figure>
      {transferingUser && call.isIncoming ? (
        call.transferedToMeStatus == 'started' ? (
          <>
            <img src={call.client.avatar} />
            <img src={transferingUser.avatar} />
          </>
        ) : (
          <>
            <img src={transferingUser.avatar} />
            <img src={call.client.avatar} />
          </>
        )
      ) : (
        <img src={call.client.avatar} />
      )}
      <div ref={remoteRef} />
    </figure>
  )
}

export default Avatar
